import { PropsWithChildren } from "react";

export const Description = ({ children }: PropsWithChildren) => (
  <div className="sm:text-lg mb-5 font-light text-[#324B4A]">{children}</div>
);
